import type { ReactNode } from 'react';
import React from 'react';
import { StatefulPopover } from 'baseui/popover';
import HorizontalSlider from '../../../../common/horizontal-slider/horizontal-slider';
import type { TOOLBAR_BUTTON_SIZE } from '../../../../common/toolbar-button';
import ToolbarButton from '../../../../common/toolbar-button';
type SliderControlPropsT = {
  value: number;
  sliderMin: number;
  sliderMax: number;
  onChange: (newValue: number) => void;
  children: ReactNode;
  title: string;
  attributes?: {
    [name: string]: string;
  };
  isSelected?: boolean;
  size?: (typeof TOOLBAR_BUTTON_SIZE)[keyof typeof TOOLBAR_BUTTON_SIZE];
  horizontal?: boolean;
  onFinalChange?: (value: number) => void;
};
function SliderControl({
  title,
  value,
  sliderMin,
  sliderMax,
  onChange,
  children,
  isSelected,
  size,
  onFinalChange,
  attributes
}: SliderControlPropsT) {
  return <StatefulPopover content={() => <HorizontalSlider min={sliderMin} max={sliderMax} value={value} onChange={onChange} onFinalChange={onFinalChange} />} overrides={{
    Body: {
      style: ({
        $theme
      }) => ({
        top: `-${$theme.sizing.scale300}`
      })
    }
  }}>
      {/** Needed to wrap with a div, as Popover was not working with statefulTootip as child */}
      <div>
        <ToolbarButton isSelected={isSelected} title={title} onClick={() => onChange(value)} size={size} attributes={attributes}>
          {children}
        </ToolbarButton>
      </div>
    </StatefulPopover>;
}
export default SliderControl;